import {useEffect, useState} from "react";
import "./IndexCalculator.css";
import {
    calculateIndex,
    getFactor,
    parseNumber,
    roundToThree,
} from "../lib/indexMath";

function IndexCalculator({onBlackoutChange = () => {}}) {
    const [formValues, setFormValues] = useState({
        volume: "",
        price: "",
        percentage: "",
    });

    const volume = parseNumber(formValues.volume);
    const price = parseNumber(formValues.price);
    const percentage = parseNumber(formValues.percentage);
    const factor = getFactor();
    const result = roundToThree(
        calculateIndex({
            percentage,
            volume,
            price,
        }),
    );

    function handleChange(event) {
        const {name, value} = event.target;

        setFormValues((currentValues) => ({
            ...currentValues,
            [name]: value,
        }));
    }

    const hasAllInputs = Object.values(formValues).every((value) => value !== "");
    const blackout = hasAllInputs && result === 0 && percentage > 0 && volume > 0;
    const pussy = hasAllInputs && percentage < 1 && volume > 0;
    const resultDisplay = !hasAllInputs
        ? "..."
        : blackout
            ? "BLACKOUT!!!"
            : pussy
                ? "Hell nah"
                : result;

    useEffect(() => {
        onBlackoutChange(Boolean(blackout));
    }, [blackout, onBlackoutChange]);

    return (
        <section className="calculator-card" aria-labelledby="calculator-title">
            <div className="calculator-intro">
                <p className="calculator-kicker">Blackout s prázdnou peněženkou</p>
                <h2 id="calculator-title">Žij chytře a spořivě</h2>
                <p>
                    Čím vyšší číslo, tím máš výhodnější koupi. Faktor{" "}
                    <strong>{factor}</strong> drží index stabilní i při změně cenové
                    hladiny Kč.
                </p>
            </div>

            <div className="input-grid">
                <label className="field">
                    <span>Celkový objem (ml)</span>
                    <input
                        name="volume"
                        type="number"
                        inputMode="decimal"
                        value={formValues.volume}
                        onChange={handleChange}
                        placeholder="500"
                    />
                </label>

                <label className="field">
                    <span>Cena (Kč)</span>
                    <input
                        name="price"
                        type="number"
                        inputMode="decimal"
                        value={formValues.price}
                        onChange={handleChange}
                        placeholder="29.90"
                    />
                </label>

                <label className="field">
                    <span>Podíl alkoholu (%)</span>
                    <input
                        name="percentage"
                        type="number"
                        inputMode="decimal"
                        value={formValues.percentage}
                        onChange={handleChange}
                        placeholder="4.7"
                    />
                </label>
            </div>

            <div className="equation" aria-label="Výpočet indexu">
                <div className="stacked-fraction">
                    <div className="fraction-body">
                        <span>{volume}</span>
                        <span className="symbol">ml</span>
                        <span className="symbol">×</span>
                        <span className="symbol">{percentage} %</span>
                    </div>
                    <hr/>
                    <span>{price} Kč</span>
                </div>

                <span className="equation-sign">×</span>
                <span className="factor-pill">{factor}</span>
                <span className="equation-sign">=</span>

                <div className="result-box">
                    <span className="result-label">Výsledek</span>
                    <strong>{resultDisplay}</strong>
                </div>
            </div>
        </section>
    );
}

export default IndexCalculator;
